import { render, staticRenderFns } from "./treatments-list-item-row.vue?vue&type=template&id=3df18b6c&"
import script from "./treatments-list-item-row.vue?vue&type=script&lang=js&"
export * from "./treatments-list-item-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports